// extracted by mini-css-extract-plugin
export default {"icon":"ExpandIcon_icon__QmSPv"};